import { useQuery } from '@tanstack/react-query';
import { Card, CardContent, CardHeader, CardTitle } from '@produzionejb/ui';
import { api } from '../../lib/api-client';

interface HealthResponse {
  status: 'ok' | 'degraded' | 'down';
  ts: string;
  uptime: number;
  db: 'ok' | 'down';
}

export function DashboardPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['health'],
    queryFn: () => api<HealthResponse>('/api/health', { auth: false }),
    refetchInterval: 30_000,
  });

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-slate-900">Dashboard</h2>
      <Card>
        <CardHeader>
          <CardTitle>Stato sistema</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm">
          {isLoading && <p className="text-slate-500">Caricamento…</p>}
          {data && (
            <>
              <p>
                <span className="font-medium text-slate-700">Status:</span>{' '}
                <span
                  className={
                    data.status === 'ok'
                      ? 'text-emerald-600'
                      : data.status === 'degraded'
                        ? 'text-amber-600'
                        : 'text-red-600'
                  }
                >
                  {data.status}
                </span>
              </p>
              <p>
                <span className="font-medium text-slate-700">Database:</span> {data.db}
              </p>
              <p>
                <span className="font-medium text-slate-700">Uptime:</span>{' '}
                {Math.round(data.uptime)}s
              </p>
              <p className="text-xs text-slate-500">{data.ts}</p>
            </>
          )}
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Prossimi passi</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-slate-700">
          <p>
            POC Glide Data Grid disponibile su{' '}
            <a href="/poc/mpg-grid" className="text-brand-700 underline">
              /poc/mpg-grid
            </a>
            .
          </p>
          <p className="text-slate-500">
            Moduli operativi (PSC / LNP / MPG / MSS / MSF / INV / Anagrafiche) — da implementare
            dopo validazione tribal knowledge con Andrei.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
